var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ImageLazy',{attrs:{"src":'/images/tracking/' + _vm.trackState[_vm.status].src,"alt":"status_logo.svg","width":"150px","height":"150px"}}),_vm._v(" "),_c('p',{attrs:{"id":"track-warning-title"}},[_vm._v("\n    "+_vm._s(_vm.trackState[_vm.status].title)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }